import AuctionsPlus from "img/AuctionsPlus";
import StockliveLogoSmall from "img/StockliveLogoSmall";

export enum ExportSite {
  AUCTIONS_PLUS = "AUCTIONS_PLUS",
  ANGUS_AUSTRALIA = "ANGUS_AUSTRALIA",
  STOCK_LIVE = "STOCK_LIVE",
  AGRINOUS = "AGRINOUS",
  LIST_2_SELL = "LIST_2_SELL",
  FARMGATE = "FARMGATE",
  THE_HERD = "THE_HERD",
}

export const ExportSitesStatuses = {
  SUCCESS: "success",
};

export const ExportSiteHeaders = {
  [ExportSite.AUCTIONS_PLUS]: "AuctionsPlus",
  [ExportSite.ANGUS_AUSTRALIA]: "Angus Australia",
  [ExportSite.STOCK_LIVE]: "Stock Live",
  [ExportSite.AGRINOUS]: "AgriNous",
  [ExportSite.LIST_2_SELL]: "List 2 Sell",
  [ExportSite.FARMGATE]: "Farm Gate",
  [ExportSite.THE_HERD]: "The Herd",
};

export const ExportSiteIcons = {
  [ExportSite.AUCTIONS_PLUS]: AuctionsPlus,
  [ExportSite.STOCK_LIVE]: StockliveLogoSmall,
};
